import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../context/LanguageContext';

const SITE_NAME = 'Croatia Times';
const SITE_URL = 'https://timescroatia.com';
const DEFAULT_DESC = 'Va\u0161 pouzdani izvor za najnovije vijesti, analize i pri\u010de iz Hrvatske i svijeta.';
const DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_d378754e-4674-4e88-b637-20552b388a6b/artifacts/82cxbgvt_CroatiaTimesLogoWebCMS.png';

export default function Meta({ title, description, image, url, type = 'website', article, noindex, canonical, jsonLd, breadcrumbs }) {
  const { t } = useLanguage();
  const pageTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} \u2014 Vijesti iz Hrvatske i svijeta`;
  const pageDesc = description || DEFAULT_DESC;
  const pageImage = image || DEFAULT_IMAGE;
  const pageUrl = canonical || url || (typeof window !== 'undefined' ? window.location.href : SITE_URL);

  const breadcrumbLd = breadcrumbs?.length > 0 ? {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((b, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": b.name,
      "item": b.url ? `${SITE_URL}${b.url}` : undefined,
    })),
  } : null;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
      <link rel="canonical" href={pageUrl} />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />}

      {/* Open Graph */}
      <meta property="og:type" content={type === 'article' ? 'article' : 'website'} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDesc} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={title || SITE_NAME} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="hr_HR" />
      <meta property="og:locale:alternate" content="en_US" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@CroatiaTimes" />
      <meta name="twitter:creator" content={article?.author ? `@${article.author.replace(/\s+/g, '')}` : '@CroatiaTimes'} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDesc} />
      <meta name="twitter:image" content={pageImage} />

      {/* Article-specific meta */}
      {article && <meta property="article:published_time" content={article.published_at} />}
      {article?.updated_at && <meta property="article:modified_time" content={article.updated_at} />}
      {article?.author && <meta property="article:author" content={article.author} />}
      {article?.category && <meta property="article:section" content={article.category} />}
      {article?.tags?.map((tag, i) => (
        <meta key={i} property="article:tag" content={tag} />
      ))}

      {/* JSON-LD structured data */}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
      {breadcrumbLd && (
        <script type="application/ld+json">{JSON.stringify(breadcrumbLd)}</script>
      )}
    </Helmet>
  );
}
